import { http } from "../http-common";
import { IUserRequest, IUserResponse } from "../types/User";

const accountBase = '/account-users';

const getMe = () => {
    return http.get<IUserResponse>(`/customers/me`);
};

const getMeUser = () => {
    return http.get<IUserResponse>(`/users/me`);
};

const get = (id: any) => {
    return http.get<IUserResponse>(`${accountBase}/${id}`);
};

const getAccountMe = () => {
    return http.get<IUserResponse>(`/accounts/me`);
};

const createAccount = (data: any) => {
    return http.post<any>(`${accountBase}`, data);
};

const toggleStatus = (id: number, newStatus: boolean, noteText?: string) => {
    const payload: any = { status: newStatus };
    if (noteText) {
        payload.note = noteText;
    }
    return http.patch(`${accountBase}/${id}/status`, payload);
}

const getAll = (params: {
    name?: string;
    page: any;
    size: any;
    sortDirection: any;
    sortField: any;
    status?: boolean;
    role?: string;
    lastLoginStart?: string;
    lastLoginEnd?: string;
    createdStart?: string;
    createdEnd?: string;
    deactivatedStart?: string;
    deactivatedEnd?: string;
}) => {
    return http.get<any[]>(accountBase, { params });
};

const getAllWithoutPagination = (search?: string) => {
    const params = search ? { params: { search } } : {};
    return http.get<any[]>(`${accountBase}/all`, params);
};

// Fetch all users without pagination using the same filters as list
const getUsersWithoutPagination = (params: {
    name?: string;
    status?: boolean;
    role?: string;
    lastLoginStart?: string;
    lastLoginEnd?: string;
    createdStart?: string;
    createdEnd?: string;
    deactivatedStart?: string;
    deactivatedEnd?: string;
}) => {
    return http.get<any>(`${accountBase}/without-pagination`, { params });
};

const getAllCustomer = (search?: string) => {
    const params = search ? { params: { search } } : {};
    return http.get<any[]>(`${accountBase}/all`, params);
};

const updateMe = (data: any) => {
    return http.patch<IUserRequest>(`/customers/me`, data);
};

const updateMeUser = (data: any) => {
    return http.patch<IUserRequest>(`/users/me`, data);
};

const update = (id: any, data: any) => {
    return http.patch<IUserRequest>(`/customers/${id}`, data);
};

const updatePassword = (data: any) => {
    return http.put<any>(`/accounts/me/password`, data);
};

const sendVerificationPhone = () => {
    return http.post<any>(`/account-users/me/verify-phone/send`);
};

const verificationPhone = (code:any) => {
    const normalizedCode = String(code ?? '').replace(/\D/g, '');
    return http.post<any>(`/account-users/me/verify-phone?code=${encodeURIComponent(normalizedCode)}`);
};

const updateEmailRequest = (data: any) => {
    return http.post<any>(`/accounts/me/email-update-request`, data);
};

const updateRole = (id: any, data: any) => {
    return http.patch<any>(`${accountBase}/${id}/change-role`, data);
};


const getAttemp = (params: { page: number; size: number; email?: string }) => {
    return http.get<IUserResponse>(`/login-attempts`, {
        params: {
            page: params.page,
            size: params.size,
            email: params.email,
        },
    });
};

const UserService = {
    getMe,
    getMeUser,
    getAccountMe,
    createAccount,
    updateMe,
    updateMeUser,
    updatePassword,
    getAll,
    updateEmailRequest,
    getAttemp,
    toggleStatus,
    get,
    update,
    getAllWithoutPagination,
    getUsersWithoutPagination,
    updateRole,
    getAllCustomer,
    sendVerificationPhone,
    verificationPhone
};

export default UserService;
